<div style=" min-height: 100vh;" class="blue-bg">
  <div class="max-page-width">
    <div class="authBg container-fluid">
      <div class="card-body">
        <div class="row">
          <div class="col-md-7 text-right d-flex align-items-center">
            <!-- register form -->
            <div class="register-form">

              <div class="text-center mb-3">
                <h1>{{ 'Register' | translate }}</h1>
                <p class="text-left">{{ 'RegisterPageFormTitle' | translate }} </p>
              </div>

              <form [formGroup]="registerForm" class="login-container text-left" (ngSubmit)="onSubmit()">
                <div *ngIf="isSubmitted && registerForm.invalid" class="required">

                  <div *ngIf="formControls.hiddenValidation.errors&&formControls.hiddenValidation.errors.Default!=null">
                    {{formControls.hiddenValidation.errors.Default}}</div>
                </div>
                <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.firstName.errors }">
                  <label>{{ 'Name' | translate }}</label>
                  <div class="row">
                    <div class="col-4 pr-0">
                      <input class="form-control" type="text" placeholder="{{ 'FirstName' | translate }}"
                        formControlName="firstName"
                        [ngClass]="{ 'has-error': isSubmitted && formControls.firstName.errors }">
                      <div *ngIf="isSubmitted && formControls.firstName.errors" class="required">
                        <div *ngIf="formControls.firstName.errors.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 pr-0">
                      <input class="form-control" type="text" placeholder="{{ 'SecondName' | translate }}"
                        formControlName="secondName"
                        [ngClass]="{ 'has-error': isSubmitted && formControls.secondName.errors }">
                      <div *ngIf="isSubmitted && formControls.secondName.errors" class="required">
                        <div *ngIf="formControls.secondName.errors.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <input class="form-control" type="text" placeholder="{{ 'LastName' | translate }}"
                        formControlName="lastName"
                        [ngClass]="{ 'has-error': isSubmitted && formControls.lastName.errors }">
                      <div *ngIf="isSubmitted && formControls.lastName.errors" class="required">
                        <div *ngIf="formControls.lastName.errors.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
                  <label>{{ 'Email' | translate }}</label>
                  <input class="form-control" type="email" placeholder="{{ 'Email' | translate }}"
                    formControlName="email" (blur)="emilBlur($event)">

                  <div class="required">
                    <!-- <div *ngIf="formControls.email.errors&&formControls.email.errors.email!=null">
                      <div class="validation-error">
                        <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidEmailAddress' | translate }}
                      </div>
                    </div> -->
                    <div *ngIf="formControls.email.errors && formControls.email.errors.exist !=null">
                      <div class="validation-error">
                        <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'EmailAlreadyExist' | translate }}
                      </div>
                    </div>
                  </div>

                  <div *ngIf="isSubmitted && formControls.email.errors?.pattern">
                    <div class="validation-error">
                      <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidEmailAddress' | translate }}
                    </div>
                  </div>


                  <div *ngIf="isSubmitted && formControls.email.errors" class="required">
                    <div *ngIf="formControls.email.errors.required">
                      <div class="validation-error">
                        <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.password.errors }">
                  <label>{{ 'Password' | translate }}</label>

                  <div class="input-group change-pass-input">
                    <input [type]="hide ?   'text' :'password' " class="form-control" type="password"
                      [pattern]="passwordPattern" placeholder="{{ 'Password' | translate }}" formControlName="password">

                    <div class="input-group-append">
                      <span class="input-group-text">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                      </span>
                    </div>
                  </div>



                  <div *ngIf="isSubmitted && formControls.password.errors" class="required">
                    <div *ngIf="formControls.password.errors.required">
                      <div class="validation-error">
                        <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                      </div>
                    </div>
                    <div *ngIf="formControls.password.errors.pattern">
                      <div class="validation-error">
                        <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RegisterPasswordValidationConstraint'
                        | translate }}
                      </div>
                    </div>
                  </div>

                </div>

                <!--Nationalty -->

                <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
                  <label>{{ 'Nationalty' | translate }}</label>




                  <mat-select panelClass="select-nationalty" class="form-control select-control " name="nationalty"
                    formControlName="nationalityID" id="nationalty" placeholder="{{ 'Nationalty' | translate }}"
                    [ngClass]="{'is-invalid':registerForm.get('nationalityID').touched&&registerForm.get('nationalityID').invalid}"
                    required>

                    <mat-option *ngFor="let location of nationalities" [value]="location.locationID">
                      {{location.locationName}}
                    </mat-option>
                  </mat-select>

                  <div *ngIf="isSubmitted && registerForm.get('nationalityID').invalid" class="invalid-feedback">
                    <div class="validation-error">
                      <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                    </div>
                  </div>



                </div>

                <div class="form-group form-check">
                  <mat-checkbox formControlName="acceptTerms" id="acceptTerms" class="form-check-input"
                    [ngClass]="{ 'has-error': isSubmitted && formControls.acceptTerms.errors }">{{
                    'AcceptTermsAndConditions' | translate }}</mat-checkbox>
                  <div *ngIf="isSubmitted && formControls.acceptTerms.errors" class="required p-25">
                    <div class="validation-error">
                      <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                    </div>
                  </div>
                </div>


                <div class="text-center">
                  <button type="submit" class="btn login-btn mt-40">{{ 'Register' | translate }}</button>
                </div>

              </form>

              <div class="login-external">
                <p> {{ 'OrSignupWith' | translate }} <a href="#"><img src='assets/img/facbookLogin.svg' /></a> <a
                    href="#"><img src='assets/img/googleLogin.svg' /></a></p>
                <p>{{ 'AlreadyHaveAnAccount' | translate }}, <a href="/login-page">{{ 'Login' | translate }}</a></p>
              </div>

            </div>
            <!-- /register form -->
          </div>
          <div class="col-md-5 p-0 text-left d-flex align-items-center">
            <img class="register-img" src='assets/img/register.svg' />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
